import { Plate } from '@alfa-retail-react/components';
import React, { Fragment } from 'react';

import { useIsDesktop } from 'app/utils/useWindowType';
import { Section } from 'app/component/Section';
import { ConfirmationPageStore } from 'app/logic/pages/confirmation/ConfirmationPageStore';
import { InlineAddressView } from 'app/logic/address/InlineAddressView';

export interface DeliveryAddressSectionProps {
    pageStore: ConfirmationPageStore;
}

export const DeliveryAddressSection = ({
    pageStore,
}: DeliveryAddressSectionProps) => {
    const [isDesktop] = useIsDesktop();
    const address = (
        <Fragment key="address">
            <div className={'deliveryAddressTitle'}>Адрес доставки</div>
            <InlineAddressView
                address={pageStore.order.deliveryAddress}
                country={pageStore.country}
                streetType={pageStore.streetType}
                localityType={pageStore.localityType}
            />
        </Fragment>
    );
    const plate = (
        <Plate view="neutral" key="delivery">
            Карта придет по почте бесплатно в течение 5 рабочих дней
        </Plate>
    );

    const content = isDesktop ? [address, plate] : [plate, address];

    return (
        <Section
            className={'deliveryAddressFormSection'}
            title={'Доставка карты почтой'}
            content={content}
        />
    );
};
